FrameModules.add('MessageUserFrameModule', function() {
   MessageUser.initialize();
});

export var MessageUser = (window.MessageUser = {
   initialize: function() {
      this.messageModal = $('messageUserModal');
      this.messageForm = $('messageUserForm');
      this.messageRecipientUserid = $('messageRecipientUserid');
      this.messageRecipientName = $('messageRecipientName');
      this.messageRecipient = $('recipientName');
      this.messageSubject = $('messageSubject');
      this.messageBody = $('messageBody');
      this.messageCancel = $('messageCancel');
      this.messageUserButtons = $$('.messageUserButton');
      if (!this.messageUserButtons.length) {
         return;
      }
      this.formManager = new FormManager(this.messageForm, {
         jumpToErrors: false,
         fixedPosition: true,
      });

      this.formManager.required('messageSubject', 'messageBody');
      this.formManager.addSubmitHandler(
         function() {
            //Submit the form using AJAX
            new Request.AjaxIO('sendMessage', {
               onSuccess: function(response) {
                  StatusPanel.notify(response.message, 2, { reload: false });
               },
            }).send(
               this.messageRecipientUserid.value,
               this.messageSubject.value,
               this.messageBody.value
            );

            Modal.forceClose();
            StatusPanel.loading(_js('Sending message...'), 100, { reload: false });

            return false;
         }.bind(this)
      );

      this.messageUserButtons.each(
         function(el) {
            el.addEvent(
               'click',
               function(ev) {
                  ev.stop();
                  Auth.required({
                     message: _js('You must be logged in to send another user a message'),
                     onAuthorize: function() {
                        var recipientUserid = el.get('data-recipient-userid');
                        var recipientName = el.get('data-recipient-name');
                        var defaultSubject = el.get('data-subject');
                        var defaultBody = el.get('data-body');

                        this.messageRecipientUserid.set('value', recipientUserid);
                        this.messageRecipientName.set('value', recipientName);
                        this.messageRecipient.set('text', recipientName);

                        if (!defaultSubject) {
                           defaultSubject = '';
                        }
                        this.messageSubject.set('value', defaultSubject);

                        if (!defaultBody) {
                           defaultBody = '';
                        }
                        this.messageBody.set('value', defaultBody);

                        Modal.open({
                           type: 'element',
                           element: this.messageModal,
                           locked: true,
                        });
                     }.bind(this),
                  });
               }.bind(this)
            );
         }.bind(this)
      );

      this.messageCancel.addEvent('click', function(ev) {
         ev.stop();
         Modal.forceClose();
      });
   },
});
